module.exports = __webpack_public_path__ + "static/clickmaps1-a5b76a2b81d7275076d62e412d500ed8.png";